<template>
  <!-- /.modal -->
  <!-- Navbar -->
  <nav style="background-color: #3a4767;">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item text-center">
        <a class="nav-link wow fadeInDown" data-widget="pushmenu" href="#" role="button" style="font-size: large;">
          <span class="text-white">Absensi Kehadiran SDA Berbasis Sistem Informasi (AKSI)</span>
        </a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto wow fadeInDown" id="navbar" style="position: fixed;right: 20px;">
      <!-- Notifications Dropdown Menu -->
      
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
export default {
  components: {
    swal
  },
  data() {
    return {
      tahun: new Date().getFullYear(),
      kodepengguna: JSON.parse(localStorage.getItem("isistem")),
      iduser: JSON.parse(localStorage.getItem("usistem")),
      namauser: JSON.parse(localStorage.getItem("nmusistem")),
      kodeiduser: JSON.parse(localStorage.getItem("tokensistem")),
      imgsistem: JSON.parse(localStorage.getItem("imgsistem")),
      username: '',
      username_tmp: '',
      password: '',
      passwordbaru: '',
      img: JSON.parse(localStorage.getItem("imgsistem")),
      folder: process.env.VUE_APP_URL_API + 'parastapainnovationgetuser-Gambar?f=' + JSON.parse(localStorage.getItem("imgsistem")),
      project_id: process.env.VUE_APP_PROJECT_ID,
      jumlahpesan: 0,
      jumlahagenda: 0,
      jumlahcomment: 0,
      idnya: '',
      komentar: [],
      datamaster: [],
      mode: '',
    };
  },
  methods: {
    
  },
  mounted() {
    //this.getOtentifikasi();
    //this.ambildata();
  },
}
</script>

<style></style>